import qs from 'qs';
import moment from 'moment';
import request from '../../../../shared/lib/request';
import { API, RPC } from '../../../../shared/constants';

const ownAnagrafica = (anagrafica) =>
  request({
    url: RPC.GESTIONE_ANAGRAFICA,
    method: 'POST',
    data: {
      method: 'associa_collaboratore',
      params: {
        anagrafica,
      },
    },
  });

const getAll = () =>
  request({
    url: API.ANAGRAFICA,
    method: 'GET',
    params: {
      'order-by': [
        {
          type: 'field',
          field: 'updatedAt',
          direction: 'desc',
        },
      ],
    },
    paramsSerializer: (params) => qs.stringify(params),
  });

const getByCodiceFiscale = (codicefiscale) =>
  request({
    url: `${API.ANAGRAFICA}`,
    method: 'GET',
    params: {
      filter: [
        {
          type: 'eq',
          field: 'codicefiscale',
          value: codicefiscale || null,
        },
      ],
    },
    paramsSerializer: (params) => qs.stringify(params),
  });

const getByCfPartial = (codicefiscale) =>
  request({
    url: `${API.ANAGRAFICA}`,
    method: 'GET',
    params: {
      filter: [
        {
          type: 'eq',
          field: 'codicefiscale',
          where: 'or',
          value: `${codicefiscale}`,
        },
      ],
    },
    paramsSerializer: (params) => qs.stringify(params),
  });

const getByPIVA = (partitaIVA) =>
  request({
    url: `${API.ANAGRAFICA}`,
    method: 'GET',
    params: {
      filter: [
        {
          type: 'eq',
          field: 'partitaiva',
          value: partitaIVA,
        },
      ],
    },
    paramsSerializer: (params) => qs.stringify(params),
  });

const getByPIVAorCF = (value) =>
  request({
    url: `${API.ANAGRAFICA}`,
    method: 'GET',
    params: {
      filter: [
        {
          type: 'orx',
          where: 'and',
          conditions: [
            {
              type: 'eq',
              field: 'partitaiva',
              value,
            },
            {
              type: 'eq',
              field: 'codicefiscale',
              value,
            },
          ],
        },
      ],
    },
    paramsSerializer: (params) => qs.stringify(params),
  });

  const getImpreseByPIVA = (partitaIVA) =>
    request({
      url: `${API.ANAGRAFICA}`,
      method: 'GET',
      params: {
        filter: [
          {
            type: 'eq',
            field: 'partitaiva',
            value: partitaIVA,
          },
          {
            type: 'eq',
            field: 'formaGiuridica',
            value: 'PG',
          },
        ],
      },
      paramsSerializer: (params) => qs.stringify(params),
    });

const getByRuoliWithSearch = (
  { ruolo, attivo, tutor, page, searchText, orderField, orderDirection, pagination, pageSize } // eslint-disable-line
) =>
  request({
    url: `${API.ANAGRAFICA}`,
    method: 'GET',
    params: {
      pagination: 'alt',
      page: page || 1,
      filter: [
        {
          type: 'search',
          value: searchText,
          ruoli: ruolo,
        },
        (attivo || tutor) && {
          type: 'innerjoin',
          field: 'dettaglioCollaboratore',
          alias: 'dettcollab',
        },
        attivo && {
          parentAlias: 'dettcollab',
          type: 'innerjoin',
          field: 'contratti',
          alias: 'contratti',
        },
        attivo && {
          alias: 'contratti',
          type: 'andx',
          where: 'and',
          conditions: [
            {
              alias: 'contratti',
              type: 'eq',
              field: 'attivo',
              value: 1,
            },
            {
              alias: 'contratti',
              type: 'orx',
              where: 'and',
              conditions: [
                {
                  alias: 'contratti',
                  type: 'isnull',
                  field: 'dataDecorrenza',
                },
                {
                  alias: 'contratti',
                  type: 'lte',
                  field: 'dataDecorrenza',
                  format: 'Y-m-d',
                  value: moment(new Date()).format('YYYY-MM-DD'),
                },
              ],
            },
            {
              alias: 'contratti',
              type: 'orx',
              where: 'and',
              conditions: [
                {
                  alias: 'contratti',
                  type: 'isnull',
                  field: 'dataRescissione',
                },
                {
                  alias: 'contratti',
                  type: 'gte',
                  field: 'dataRescissione',
                  format: 'Y-m-d',
                  value: moment(new Date()).format('YYYY-MM-DD'),
                },
              ],
            },
          ],
        },
        tutor && {
          alias: 'dettcollab',
          type: 'eq',
          where: 'and',
          field: 'tutor',
          value: 1,
        },
      ].filter((o) => o),
      'order-by': [
        {
          type: 'field',
          field: orderField && orderDirection !== 'none' ? orderField : 'updatedAt',
          direction: orderDirection !== 'none' && orderDirection ? orderDirection : 'desc',
        },
      ],
    },
    paramsSerializer: (params) => qs.stringify(params),
  });

const getByRuoliWithSearchLight = (
  { ruolo, senzaPrivacy = false, tipologiaAnagrafica = null, page, searchText, orderField, orderDirection } // eslint-disable-line
) =>
  request({
    url: `${API.ANAGRAFICA}`,
    method: 'GET',
    params: {
      pagination: 'alt',
      show: 'true',
      fields:
        'id,nominativo,codicefiscale,recapiti,allegatoPrivacy,assegnatoA,liveIdRequests,videoRiconosciuto,scadenzaVideoRiconoscimento,createdAt,dataCompletamentoVideoRiconoscimento,formaGiuridica',
      page: page || 1,
      filter: [
        {
          type: 'search',
          value: searchText,
          ruoli: ruolo,
        },
        !!senzaPrivacy && {
          type: 'isnull',
          field: 'allegatoPrivacy',
        },
        !!tipologiaAnagrafica && {
          type: 'eq',
          field: 'formaGiuridica',
          value: tipologiaAnagrafica,
        },
      ].filter(Boolean),
      'order-by': [
        {
          type: 'field',
          field: orderField && orderDirection !== 'none' ? orderField : 'updatedAt',
          direction: orderDirection !== 'none' && orderDirection ? orderDirection : 'desc',
        },
      ],
    },
    paramsSerializer: (params) => qs.stringify(params),
  });

const getByRuoli = (ruolo, page, noPagination) =>
  request({
    url: `${API.ANAGRAFICA}`,
    method: 'GET',
    params: {
      pagination: !noPagination,
      page: page || 1,
      filter: [
        {
          type: 'leftjoin',
          field: 'ruoli',
          alias: 'ruolo',
        },
        {
          type: 'eq',
          alias: 'ruolo',
          field: 'nome',
          value: ruolo || null, // 'Prospect'
        },
      ],
    },
    paramsSerializer: (params) => qs.stringify(params),
  });

const getAllCollaboratori = () =>
  request({
    url: `${API.COLLABORATORE}`,
    method: 'GET',
    params: {
      pagination: false,
      fieldsToExtract: ['row.id', 'a.nominativo'],
      filter: [
        {
          type: 'innerJoin',
          alias: 'a',
          field: 'anagrafica',
        },
      ],
    },
    paramsSerializer: (params) => qs.stringify(params),
  });

const getByRuoliAttivi = (ruolo, page, noPagination) =>
  request({
    url: `${API.ANAGRAFICA}`,
    method: 'GET',
    params: {
      pagination: !noPagination,
      page: page || 1,
      filter: [
        {
          type: 'leftjoin',
          field: 'ruoli',
          alias: 'ruolo',
        },
        {
          type: 'eq',
          alias: 'ruolo',
          field: 'nome',
          value: ruolo || null, // 'Prospect'
        },
        {
          type: 'eq',
          field: 'attivol3',
          value: true,
        },
        {
          type: 'eq',
          field: 'activeMobile',
          value: true,
        },
      ],
    },
    paramsSerializer: (params) => qs.stringify(params),
  });

const getByRuoliOptions = (ruolo, page) =>
  getByRuoli(ruolo, page)
    .then((res) => res._embedded.anagrafica.map((obj) => ({ value: obj.id, label: obj.nominativo })))
    .then((data) => ({ options: data }));

const getAnagraficheCollaboratoriOptions = () =>
  getAllCollaboratori()
    .then((res) => res._embedded.collaboratore.map((obj) => ({ value: obj.id, label: obj.nominativo })))
    .then((data) => ({ options: data }));

const getAnagraficheCollaboratori = (noPagination) =>
  getByRuoli('Collaboratore', 1, noPagination)
    .then((res) =>
      res._embedded.anagrafica.map((obj) => ({ value: obj.dettaglioCollaboratore.id, label: obj.nominativo }))
    )
    .then((data) => ({ options: data }));

const getAnagraficheCollaboratoriAttive = (noPagination) =>
  getByRuoliAttivi('Collaboratore', 1, noPagination)
    .then((res) =>
      res._embedded.anagrafica.map((obj) => ({ value: obj.dettaglioCollaboratore.id, label: obj.nominativo }))
    )
    .then((data) => ({ options: data }));

const getByNominativo = (nominativo) =>
  request({
    url: `${API.ANAGRAFICA}`,
    method: 'GET',
    params: {
      filter: [
        {
          type: 'eq',
          field: 'nominativo',
          value: nominativo || null,
        },
      ],
    },
    paramsSerializer: (params) => qs.stringify(params),
  });

const getByNominativoAndRecapiti = (nominativo, recapiti, anagraficaId, codicefiscale) => {
  const RecapitiMap =
    Array.isArray(recapiti) &&
    recapiti.map((recapito) => ({
      type: 'eq',
      where: 'or',
      field: 'nome',
      alias: 'r',
      value: recapito.nome || null,
    }));

  const filters = [
    {
      type: 'eq',
      where: 'or',
      field: 'nominativo',
      value: nominativo || null,
    },
    {
      type: 'neq',
      where: 'and',
      field: 'id',
      value: anagraficaId || null,
    },
    codicefiscale && {
      type: 'eq',
      field: 'codicefiscale',
      value: '',
    },
  ].filter((o) => o);

  const recapitiFilters = [
    {
      type: 'leftjoin',
      field: 'recapiti',
      alias: 'r',
    },
    ...RecapitiMap,
  ];

  if (recapitiFilters.length > 1) {
    filters.splice(1, 0, ...recapitiFilters);
  }

  return request({
    url: `${API.ANAGRAFICA}`,
    method: 'GET',
    params: {
      filter: filters,
    },
    paramsSerializer: (params) => qs.stringify(params),
  });
};

const get = (id) =>
  request({
    url: `${API.ANAGRAFICA}/${id}`,
    method: 'GET',
  });

const put = (content) =>
  request({
    url: `${API.ANAGRAFICA}/${content.id}`,
    method: 'PUT',
    data: content,
    raw: true,
  });

const del = (id) =>
  request({
    url: `${RPC.GESTIONE_ANAGRAFICA}`,
    method: 'POST',
    data: {
      method: 'delete-anagrafica',
      params: {
        anagrafica: id,
      },
    },
  });

const anonymizeAnagarafica = (anagraficaId) =>
  request({
    url: `${RPC.GESTIONE_ANAGRAFICA}`,
    method: 'POST',
    data: {
      method: 'anonymize_anagrafica',
      params: {
        anagraficaId,
      },
    },
  });

const manageSharedMail = (anagraficaId, isCoordinatore = false) =>
  request({
    url: `${RPC.GESTIONE_ANAGRAFICA}`,
    method: 'POST',
    data: {
      method: 'manage_shared_mail',
      params: {
        anagraficaId,
        isCoordinatore,
      },
    },
  });

const create = (content) =>
  request({
    url: API.ANAGRAFICA,
    method: 'POST',
    data: content,
    raw: true,
  });

const getPIVA = (anagraficaId) => get(anagraficaId).then((res) => res.partitaiva);

const getPrivacyLogByAnagrafica = (anagraficaId) =>
  request({
    url: `${API.PRIVACY_LOGGER}`,
    method: 'GET',
    params: {
      page_size: -1,
      'order-by': [
        {
          type: 'field',
          field: 'dataLog',
          direction: 'desc',
        },
      ],
      filter: [
        {
          type: 'eq',
          field: 'anagrafica',
          value: anagraficaId,
        },
      ],
    },
    paramsSerializer: (params) => qs.stringify(params),
  });

const AnagraficaService = {
  getAll,
  get,
  getPIVA,
  getByCodiceFiscale,
  getByCfPartial,
  getByPIVA,
  getByPIVAorCF,
  getImpreseByPIVA,
  getByNominativo,
  getByNominativoAndRecapiti,
  getAnagraficheCollaboratori,
  getAnagraficheCollaboratoriAttive,
  getByRuoli,
  getByRuoliWithSearch,
  getByRuoliWithSearchLight,
  getByRuoliOptions,
  create,
  del,
  put,
  ownAnagrafica,
  getAllCollaboratori,
  getAnagraficheCollaboratoriOptions,
  anonymizeAnagarafica,
  getPrivacyLogByAnagrafica,
  manageSharedMail,
};

export default AnagraficaService;



// WEBPACK FOOTER //
// ./app/shared/services/api/anagrafica/index.js